import { Box, Button, Card, CardContent, CardMedia, Paper, Typography } from '@mui/material';
import { FC } from 'react';
import { Helmet } from 'react-helmet';
import { authManager } from 'services/auth';
import { IS_NEMAN } from 'services/constants/env';
import { DEFAULT_AUTHORIZED_PATH } from 'routes/constants';

export const SignedOut: FC = () => {
	const failureReason = authManager.getHandshakeFailureReason();

	return (
		<>
			<Helmet>
				<title>Signed out</title>
				<link rel="icon" href={`${IS_NEMAN ? '/favicon-neman.ico' : '/favicon.ico'}`} />
			</Helmet>
			<Box
				sx={{
					display: 'flex',
					alignContent: 'center',
					justifyContent: 'center',
					// height: { xs: '100vh', sm: 'auto' },
					height: '100vh',
					// height: '100vh',
					// width: '100vw',
					color: '#016193',
					position: 'relative',
					backgroundColor: '#052437',
					padding: 0,
					margin: 0,
					// overflow: 'hidden',
					// zIndex: 1000,
				}}
			>
				{' '}
				<Card
					sx={{
						width: { xs: '100%', sm: 400 },
						height: { xs: '100vh', sm: '460px' },
						textAlign: 'center',
						mt: { sm: '10vh', xs: 0 },
						color: '#016193',
						position: 'relative',
						zIndex: 1000,
						'&.MuiCard-root': {
							borderRadius: { sm: '12px!important', xs: '0!important' },
						},
					}}
				>
					<CardMedia sx={{ height: 160 }} image="/img/fon.png" />
					<div
						style={{
							position: 'absolute',
							top: 0,
							left: 0,
							maxWidth: '100%',
							padding: '10px 130px',
						}}
					>
						<img
							src="/img/EAS-logo-invert.svg"
							alt=""
							style={{
								width: '100%',
								height: '100%',
							}}
						/>
					</div>
					<CardContent>
						<Box sx={{ p: 5 }}>
							<Typography variant="h6" component="h1" sx={{ mt: 4 }}>
								{failureReason ? 'Could not complete sign-in' : 'You are signed out'}
							</Typography>
							{failureReason && (
								<Typography variant="caption" component="p" sx={{ mt: 1, color: 'text.secondary' }}>
									{failureReason}
								</Typography>
							)}
							<Button
								variant="contained"
								size="large"
								sx={{ width: '100%', mt: 4 }}
								onClick={() => {
									void authManager.signInAgain(
										authManager.getPendingReturnTo() ?? DEFAULT_AUTHORIZED_PATH,
									);
								}}
							>
								Sign in
							</Button>
						</Box>
					</CardContent>
				</Card>
			</Box>
		</>
	);
};
